<template>
  <div class="services">
    <div class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-10.jpg')})`}"
        style="background:no-repeat center center;">
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">自助设备</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">产品信息</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row flex-row">
            <div class="col-sm-8 col-xs-12">
              <h4 class="text-primary">设备介绍</h4>
              <h2>酒店人脸识别自助开房机</h2>
              <div class="industris-space-10 sm-hidden"></div>
							<p>
                <!-- <i class="fa fa-play"></i> &nbsp; -->
                快速入住退房 - 20秒钟完成一次入住 - 5秒完成退房
              </p>
							<p>
                <!-- <i class="fa fa-play"></i> &nbsp; -->
                实现全程自助开房和退房，全程简单快捷，无需酒店人员参与，真正实现酒店客人可以做到来无影去无踪，更好的保护客人隐私
              </p>
              <br />
            </div>
						<div class="col-md-4 col-sm-12 align-self-center">
              <img src="../assets/images/zzj-5.png" alt />
            </div>
            <!-- <div class="col-sm-4 col-xs-12 align-self-center">
              <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
                <swiper-slide>
                  <img src="../assets/images/zzj-1.png" alt />
                </swiper-slide>

                <swiper-slide>
                  <img src="../assets/images/zzj-2.png" alt />
                </swiper-slide>

                <swiper-slide>
                  <img src="../assets/images/zzj-3.png" alt />
                </swiper-slide>

                <swiper-slide>
                  <img src="../assets/images/zzj-4.png" alt />
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </div> -->
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <h3>优势特点</h3>
              <div class="industris-space-10 sm-hidden"></div>
              <p>
                <i class="fa fa-play"></i> &nbsp;
                <b>减少总台服务人员，降低酒店经营成本</b>
                <br />&nbsp;&nbsp;&nbsp;&nbsp;由于许多宾客都到自助开房机上开房、续住和结账，大大减少了总台的工作量，从而可以减少前台服务人员的配备，从而降低经营成本
              </p>

              <p>
                <i class="fa fa-play"></i> &nbsp;
                <b>方便、快捷</b>
                <br />&nbsp;&nbsp;&nbsp;&nbsp;简单的自助操作系统，避免到前台排队等候，会员20秒入住，散客40秒入住的超快入住流程，让客人无需过多时间等待即可自主完成入住
              </p>

              <p>
                <i class="fa fa-play"></i> &nbsp;
                <b>增强宾客的如家感觉</b>
                <br />&nbsp;&nbsp;&nbsp;&nbsp;自助系统充分发挥客人的主观能动性，节约办理手续时漫长的等待避免反复缴、退押金带来的烦琐手续
              </p>

              <p>
                <i class="fa fa-play"></i> &nbsp;
                <b>树立品牌形象，提高会员的忠诚度</b>
                <br />&nbsp;&nbsp;&nbsp;&nbsp;触摸屏外观美观，自助系统操作简便，一定会让客人感受到酒店的高品位，享受高科技带来的体验和乐趣，提升酒店形象，提高顾客忠诚度
              </p>
              <div class="industris-space-xs"></div>
            </div>
          </div>
          <div class="industris-space-90 sm-hidden"></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "services_zzj",
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.swiper.slideTo(5, 1000, false);
  },
};
</script>

<style>
.fa-play {
  color: #1a94e6;
}
.swiper {
  text-align: center;
}
.swiper-pagination {
  margin-top: -30px;
  margin-left: 45%;
}
.swiper-slide img:hover {
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/pages/services_zzj.vue